import {useQueryParams, useSearch} from '@aboutyou/router';
import {updateUrlParams} from '../../../shared-deprecated/updateUrlParams';

export const unisexOnlineMarketingParam = 'omUnisex';

export const useIsOmEntry = () => {
  const queryParams = useQueryParams();

  return {
    isUnisex: queryParams.get(unisexOnlineMarketingParam) === '1',
  };
};

export const useSearchWithoutOmEntryParam = () => {
  const search = useSearch();

  return updateUrlParams({
    search,
    update: new Map([[unisexOnlineMarketingParam, undefined]]),
  });
};
